(function() {
  let comicURL,
    imageURL,
    userURLField,
    comicURLPropertyField,
    comicImageURLPropertyField,
    errorMessage,
    errorMessageField,
    previewContainer,
    previewFrame,
    previewImage,
    previewLoadingSpinner,
    previewText,
    fetchedImageURLs = {},
    URLFieldResponseTimeout,
    validatingMessage,
    buyItNowButton,
    addToCartButton,
    verticalOrientation = false;

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }

  /**
   * Set one of the following states:
   * - validComic
   * - emptyField
   * - loading
   * - error
   *
   * @param {string} state
   */
  function setState(state) {
    if ('validComic' === state) {
      hideErrorMessage();
      showFrame();
      showImagePreview();
      hideValidatingMessage();
      hidePreviewTextOverlay();
      hidePreviewLoadingSpinner();
      setHiddenFields();
      allowCheckout();

    } else if ('emptyField' === state) {
      preventCheckout();
      clearHiddenFields();
      hideErrorMessage();
      hideImagePreview();
      hidePreviewLoadingSpinner();
      hideValidatingMessage();
      showPreviewTextOverlay();

    } else if ('loading' === state) {
      preventCheckout();
      clearHiddenFields();
      hideErrorMessage();
      hideImagePreview();
      showPreviewLoadingSpinner();
      showValidatingMessage();
      hidePreviewTextOverlay();

    } else if ('error' === state) {
      preventCheckout();
      clearHiddenFields();
      hideValidatingMessage();
      showErrorMessage();
      hideImagePreview();
      hidePreviewLoadingSpinner();
      showPreviewTextOverlay();
    }
  }

  function hidePreviewLoadingSpinner() {
    previewLoadingSpinner.classList.add('hidden');
  }

  function showPreviewLoadingSpinner() {
    previewLoadingSpinner.classList.remove('hidden');
  }

  function debounceURLFieldChange() {
    if (URLFieldResponseTimeout) {
      clearTimeout(URLFieldResponseTimeout);
      URLFieldResponseTimeout = null;
    }
    URLFieldResponseTimeout = setTimeout(parseURLField, 400);
  }

  function parseURLField() {
    const fieldValue = userURLField.value;

    if (!fieldValue) {
      setErrorMessage('Please enter a URL for the comic strip.');
      setState('error');
      return;
    }

    if (!isUrlValid(fieldValue)) {
      setErrorMessage('Please enter a valid URL.');
      setState('error');
      return;
    }

    if (!validateURL(fieldValue)) {
      setErrorMessage("Please enter the URL of a comic's page on comicskingdom.com.");
      setState('error');
      return;
    }

    clearErrorMessage();
    fetchDataFromURL(fieldValue);
  }

  function init() {
    initVariables();

    if (userURLField) {
      userURLField.addEventListener('input', debounceURLFieldChange);
    }

    showFrame();
    setState('emptyField');

    const variantSelector = document.querySelector('variant-radios');
    if (variantSelector) {
      variantSelector.addEventListener('click', showFrame);
    }

    getDataFromURL();
    if (comicURL && !imageURL) {
      fetchDataFromURL(comicURL);
    }

    if (imageURL) {
      testImage();
    }
  }

  function initVariables() {
    userURLField = document.getElementById('comic-url--user');

    comicURLPropertyField = document.getElementById('comicURLProperty');
    comicImageURLPropertyField = document.getElementById('comicImageURLProperty');

    errorMessageField = document.getElementById('comic-url-error');
    previewContainer = document.getElementById('comic-preview-container');
    previewFrame = document.getElementById('comic-preview-frame');
    previewImage = document.getElementById('comic-preview-image');
    previewText = document.getElementById('comic-preview-overlay-text');
    previewLoadingSpinner = previewContainer.querySelector('.loading__spinner');
    validatingMessage = document.getElementById('comic-url-validating');

    addToCartButton = document.querySelector('.product-form__buttons .product-form__submit');
    buyItNowButton = document.querySelector('.product-form__buttons .shopify-payment-button');
  }

  function respondImageError() {
    setErrorMessage('No comic was found at that URL. Please try again.');
    setState('error');
  }

  function respondImageLoadSuccessful() {
    verticalOrientation = this && this.width < this.height;
    setState('validComic');
  }

  /**
   * ORIGINAL showFrame() — restored exactly
   */
  function showFrame() {
  let frameURL = `${assetDirectory}frame`;

  // Frame color
  const frameRadioButton = document.querySelector('variant-radios input[name="Frame"]:checked');
  if (!frameRadioButton || 'black' === frameRadioButton.value.toLowerCase()) {
    frameURL += '-black';
  } else if ('white' === frameRadioButton.value.toLowerCase()) {
    frameURL += '-white';
  } else if ('no frame' === frameRadioButton.value.toLowerCase()) {
    frameURL += '-noframe';
  }

  // Frame size (mapping 8x10 → 12x18)
  const sizeRadioButton = document.querySelector('variant-radios input[name="Size"]:checked');
  let sizeValue = sizeRadioButton ? sizeRadioButton.value : '12" x 18"';

  // Shrink preview by 5% for 8x10
  if (sizeValue === '8" x 10"') {
    // apply 95% scale
    previewImage.style.transform = 'scale(0.95)';
    previewImage.style.transformOrigin = 'center center';
    sizeValue = '12" x 18"';  // maintain 12x18 frame logic
  } else {
    // reset scale for all other sizes
    previewImage.style.transform = 'scale(1)';
  }

  // Frame selection by size
  if (sizeValue === '12" x 18"') {
    frameURL += '-12x18';
  } else if (sizeValue === '18" x 24"') {
    frameURL += '-18x24';
  }

  // Orientation
  if (verticalOrientation) {
    frameURL += "-vertical";
    previewContainer.classList.add('verticalOrientation');
  } else {
    previewContainer.classList.remove('verticalOrientation');
  }

  frameURL += '.png';
  previewFrame.src = frameURL;
  previewFrame.style.display = 'block';
}

  function allowCheckout() {
    addToCartButton.disabled = false;
    buyItNowButton.disabled = false;
  }

  function preventCheckout() {
    addToCartButton.disabled = true;
    buyItNowButton.disabled = true;
  }

  function showValidatingMessage() {
    clearErrorMessage();
    validatingMessage.style.display = 'block';
  }

  function hideValidatingMessage() {
    validatingMessage.style.display = 'none';
  }

  function showPreviewTextOverlay() {
    previewText.style.display = 'block';
  }

  function hidePreviewTextOverlay() {
    previewText.style.display = 'none';
  }

  function hideImagePreview() {
    if (!previewContainer || !previewImage) return;
    previewImage.style.display = 'none';
  }

  function testImage() {
    const newImage = new Image();
    newImage.onload = respondImageLoadSuccessful;
    newImage.onerror = respondImageError;
    newImage.src = imageURL;

    if (newImage.complete) {
      respondImageLoadSuccessful.apply(newImage);
    }
  }

  function showImagePreview() {
    if (!imageURL || !previewImage) return;
    previewImage.src = imageURL;
    previewImage.style.display = 'block';
  }

  function isUrlValid(url) {
    const pattern = new RegExp(
      '^(https?:\\/\\/)?' +
        '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' +
        '((\\d{1,3}\\.){3}\\d{1,3}))' +
        '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' +
        '(\\?[;&a-z\\d%_.~+=-]*)?' +
        '(\\#[-a-z\\d_]*)?$',
      'i'
    );
    return pattern.test(url);
  }

  function clearHiddenFields() {
    comicImageURLPropertyField.value = '';
    comicURLPropertyField.value = '';
  }

  function setHiddenFields() {
    comicImageURLPropertyField.value = imageURL;
    comicURLPropertyField.value = comicURL;
  }

  function clearErrorMessage() {
    errorMessage = '';
  }

  function hideErrorMessage() {
    errorMessageField.innerText = '';
  }

  function showErrorMessage() {
    errorMessageField.innerText = errorMessage;
  }

  function setErrorMessage(message) {
    if (message === errorMessage) return;
    errorMessage = message;
  }

  function fetchDataFromURL(url) {
    if (!url) return;

    setState('loading');

    url = maybeAddDomainName(decodeURIComponent(url));
    if (!validateURL(url)) {
      setErrorMessage('Please enter a valid URL');
      setState('error');
      return;
    }

    if (fetchedImageURLs[url]) {
      imageURL = fetchedImageURLs[url];
      comicURL = url;
      respondImageLoadSuccessful();
      return;
    }

    comicURL = url;

    fetch(url)
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.text();
      })
      .then(html => {
        const image = findImageInHTML(html);
        if (image) {
          comicURL = url;
          comicURLPropertyField.value = comicURL;
          imageURL = image;
          comicImageURLPropertyField.value = imageURL;
          fetchedImageURLs[url] = image;
          testImage();
        } else {
          throw new Error();
        }
      })
      .catch(error => {
        setErrorMessage("No comic was found at that URL. Please try again.");
        setState('error');
      });
  }

  function findImageInHTML(html) {
    if (!html) return;

    let maybeImageURL =
      html.match(/<meta property="og:image" content="([^"]+)"/);
    if (maybeImageURL && typeof maybeImageURL[1] !== 'undefined') {
      return decodeURIComponent(maybeImageURL[1]);
    }

    maybeImageURL = html.match(
      /<link .*rel="preload" .*imageSrcSet="[^"]+\?url=([^&"]+)&/
    );
    if (maybeImageURL && typeof maybeImageURL[1] !== 'undefined') {
      return decodeURIComponent(maybeImageURL[1]);
    }
  }

  function validateURL(url) {
    return url.match(
      /(https?:\/\/)?(www\.)?comicskingdom\.com\/(vintage\/)?[^\/]+\/[^\/]+\/?$/
    );
  }

  function maybeAddDomainName(url) {
    if (!url.includes('comicskingdom.com/')) {
      url = 'https://comicskingdom.com/' + url;
      url = url.replace('.com//', '.com/');
    }
    return url;
  }

  function getDataFromURL() {
    if (!window.location.search) return;

    const urlParams = new URLSearchParams(window.location.search);
    let maybeURL = urlParams.get('url');

    if (!maybeURL) return;

    maybeURL = maybeAddDomainName(decodeURIComponent(maybeURL));

    if (!validateURL(maybeURL)) return;

    comicURL = maybeURL;

    if (!userURLField.value) {
      userURLField.value = comicURL;
      comicURLPropertyField.value = comicURL;
    }

    imageURL = urlParams.get('img');

    if (imageURL) {
      imageURL = decodeURIComponent(imageURL);
      imageURL = imageURL.replaceAll('&amp;', '&');
      setState('validComic');
    }
  }
})();
